import React from 'react';
import axios from 'axios';
import { fetchAcademicYears, fetchMunicipality, fetchCurrentAcademicYear } from '../Lookups/util';
import { Table, Form, Header, Segment, Loader, Grid } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class EnrolledStudentsPerMunicipalityForBiH extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            academicYears: [],
            academicYear: '',
            citizenship: '',
            data: [],
            municipalities: [],
            currentAcademicYear: '',

            loading: true,
            showChart: false
        };

        this.fetchMunicipalityAndAcademicYears = this.fetchMunicipalityAndAcademicYears.bind(this);
        this.generateChartData = this.generateChartData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getAcademicYearName = this.getAcademicYearName.bind(this);
        this.getMunicipalityName = this.getMunicipalityName.bind(this);
    }


    componentDidMount() {
        this.fetchMunicipalityAndAcademicYears();
    }

    getMunicipalityName(id) {
        const { municipalities } = this.state;
        const selected = municipalities.find(el => el.id === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getAcademicYearName() {
        const { academicYear, academicYears } = this.state;
        const selected = academicYears.find(el => el.id === academicYear);
        if (selected && selected.name) return selected.name;
        return '';
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    fetchMunicipalityAndAcademicYears() {
        axios.all([fetchAcademicYears(), fetchMunicipality(), fetchCurrentAcademicYear()])
            .then(axios.spread((academicYearsRes, municipalitiesRes, currentAcademicYearRes) => {
                const currentAcademicYear = currentAcademicYearRes.data.id;
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const municipalities = municipalitiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    academicYears, municipalities, loading: false, currentAcademicYear
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch academic years or municipalities');
            });
    }

    generateChartData() {
        const { academicYear } = this.state;
        axios.get(`/statistics/enrolled-per-municipality-for-BiH-for-university?academicYearId=${academicYear}`)
            .then(res => {
                const data = res.data.sort((a, b) => b.numberOfStudents - a.numberOfStudents).map(el => ({
                    ...el, name: this.getMunicipalityName(el.placeId), value: el.numberOfStudents
                }));
                this.setState({ data, showChart: true });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results');
            });
    }


    render() {
        const { data } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1">{<FormattedMessage id="statistics.statistic" />}</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            {<FormattedMessage id="statistics.selectAcademicYear" />}
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>{<FormattedMessage id="common.academicYear" />}</label>
                                    <Form.Dropdown
                                        placeholder={<FormattedMessage id="statistics.selectAcademicYear" />}
                                        value={this.state.academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                                <Form.Button label=" " color="blue" basic="true" onClick={this.generateChartData}>{<FormattedMessage id="common.show" />}</Form.Button>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>

                {this.state.showChart && <Grid columns="equal" centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Header as="h2">
                                {<FormattedMessage id="common.unsa" />}
                            </Header>
                            <Header as="h3">{<FormattedMessage id="statistics.headerNumberEnrolledStudents" />} {this.getAcademicYearName()} {<FormattedMessage id="statistics.headerAcademicYear" />} </Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment>
                                    <Header as="h3">{<FormattedMessage id="statistics.tableShow" />} </Header>
                                </Segment>
                                {data.length ? <Segment>
                                    <Table celled selectable compact>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>{<FormattedMessage id="common.municipality" />} </Table.HeaderCell>
                                                <Table.HeaderCell>{<FormattedMessage id="statistics.numberOfStudents" />} </Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>  {data.map((el) =>

                                            (<Table.Row key={el.name}>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.name}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.value}
                                                </Table.Cell>
                                            </Table.Row>))}
                                        </Table.Body>
                                    </Table>
                                    <br />
                                </Segment>
                                    : <Segment>
                            Nema podataka za odabranu akademsku godinu.
                                    </Segment>}
                            </Segment.Group >
                        </Grid.Column>

                        {/*  <Grid.Column>
                            <Segment.Group raised>
                                <Segment>
                                    <Header as="h3">Grafički prikaz</Header>
                                </Segment>
                                <Segment>

                                </Segment>

                            </Segment.Group>
                        </Grid.Column> */}
                    </Grid.Row>
                </Grid>}
            </div>
        );
    }
}

export default EnrolledStudentsPerMunicipalityForBiH;



// WEBPACK FOOTER //
// ./src/views/Statistics/EnrolledStudentsPerMunicipalityForBiHForUniversity.js